import { useEffect, useState } from "react";
import { TOAST_EVENT } from "../../utils/toast";
import "./ToastHost.css";

function ToastHost() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    function onToast(event) {
      const detail = event?.detail;
      if (!detail?.message) return;
      setItems((prev) => [...prev, detail]);
      const duration = Number(detail.duration) > 0 ? Number(detail.duration) : 3200;
      window.setTimeout(() => {
        setItems((prev) => prev.filter((item) => item.id !== detail.id));
      }, duration);
    }

    window.addEventListener(TOAST_EVENT, onToast);
    return () => {
      window.removeEventListener(TOAST_EVENT, onToast);
    };
  }, []);

  return (
    <div className="toast-host" aria-live="polite" aria-atomic="false">
      {items.map((item) => (
        <div key={item.id} className={`toast-host__item toast-host__item--${item.type || "info"}`}>
          {item.message}
        </div>
      ))}
    </div>
  );
}

export default ToastHost;
